import { Card, CardContent } from "@/components/ui/card";
import { Send, CheckCircle, Clock, XCircle } from "lucide-react";

interface ProposalSummaryCardsProps {
  totalSentCount: number;
  totalSentValue: number;
  acceptedCount: number;
  acceptedValue: number;
  pendingCount: number;
  pendingValue: number;
  rejectedCount: number;
  rejectedValue: number;
}

export function ProposalSummaryCards({
  totalSentCount,
  totalSentValue,
  acceptedCount,
  acceptedValue,
  pendingCount,
  pendingValue,
  rejectedCount,
  rejectedValue,
}: ProposalSummaryCardsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center space-x-2">
            <Send className="h-4 w-4 text-primary" />
            <div>
              <p className="text-sm text-muted-foreground">Total Sent</p>
              <p className="text-lg font-bold">
                {totalSentCount.toLocaleString()} • €{totalSentValue.toLocaleString()}
              </p>
              <p className="text-xs text-muted-foreground">vs. YA</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center space-x-2">
            <CheckCircle className="h-4 w-4 text-primary" />
            <div>
              <p className="text-sm text-muted-foreground">Accepted</p>
              <p className="text-lg font-bold">
                {acceptedCount.toLocaleString()} • €{acceptedValue.toLocaleString()}
              </p>
              <p className="text-xs text-muted-foreground">vs. YA</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center space-x-2">
            <Clock className="h-4 w-4 text-primary" />
            <div>
              <p className="text-sm text-muted-foreground">Pending response</p>
              <p className="text-lg font-bold">
                {pendingCount.toLocaleString()} • €{pendingValue.toLocaleString()}
              </p>
              <p className="text-xs text-muted-foreground">vs. YA</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center space-x-2">
            <XCircle className="h-4 w-4 text-primary" />
            <div>
              <p className="text-sm text-muted-foreground">Rejected</p>
              <p className="text-lg font-bold">
                {rejectedCount.toLocaleString()} • €{rejectedValue.toLocaleString()}
              </p>
              <p className="text-xs text-muted-foreground">vs. YA</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
